const Menu = [
  {
    id: 1,
    name: "Apple",
    price: 120,
    category: "Fruits",
    image: "assets/Apple.png",
    desc: "An apple is a sweet, edible fruit produced by an apple tree (Malus domestica). Apple trees are ... The skin of ripe apples is generally red, yellow, green, pink, or russetted, though many bi- or tri-colored cultivars may be found.",
  },
  {
    id: 2,
    name: "Banana",
    price: 50,
    category: "Fruits",
    image: "assets/Banana.png",
    desc: "A banana is an elongated, edible fruit – botanically a berry – produced by several kinds of large herbaceous flowering plants in the genus Musa. In some countries, bananas used for cooking may be called plantains, distinguishing them from dessert bananas.",
  },
  {
    id: 3,
    name: "Orange",
    price: 90,
    category: "Fruits",
    image: "assets/Orange.png",
    desc: "The orange is the fruit of various citrus species in the family Rutaceae; it primarily refers to Citrus × sinensis, which is also called sweet orange, to distinguish it from the related Citrus × aurantium, referred to as bitter orange.",
  },
  {
    id: 4,
    name: "Potatos",
    price: 70,
    category: "Vegetables",
    image: "assets/Potatos.png",
    desc: "Potatoes are a good source of fiber, which can help you lose weight by keeping you full longer. Fiber can help prevent heart disease by keeping cholesterol and blood sugar levels in check. Potatoes are also full of antioxidants that work to prevent diseases and vitamins that help your body function properly.",
  },
  {
    id: 5,
    name: "Onion",
    price: 40,
    category: "Vegetables",
    image: "assets/Onion.png",
    desc: "The onion, also known as the bulb onion or common onion, is a vegetable that is the most widely cultivated species of the genus Allium. The shallot is a botanical variety of the onion. Until 2010, the shallot was classified as a separate species.",
  },
  {
    id: 6,
    name: "Tomatoes",
    price: 30,
    category: "Vegetables",
    image: "assets/Tomatoes.png",
    desc: "Tomatoes are loaded with a substance called lycopene. It gives them their bright red color and helps protect them from the ultraviolet rays of the sun. In much the same way, it can help protect your cells from damage. Tomatoes also have potassium, vitamins B and E, and other nutrients.",
  },
  {
    id: 7,
    name: "Goat Meat",
    price: 180,
    category: "Fresh Meat",
    image: "assets/GoatMeat.png",
    desc: "Lamb, hogget, and mutton, generically sheep meat, are the meat of domestic sheep , Ovis aries. A sheep in its first year may be a lamb and its meat is additionally lamb. The meat from sheep in their second year is hogget. Older sheep meat is mutton. Generally, “hogget” and “sheep meat” aren’t employed by consumers outside New Zealand, South Africa and Australia.",
  },
  {
    id: 8,
    name: "Beef",
    price: 130,
    category: "Fresh Meat",
    image: "assets/Beef.png",
    desc: "Beef is that the culinary name for meat from cattle. In prehistoric times, humans hunted aurochs and later domesticated them. Since then, numerous breeds of cattle are bred specifically for the standard or quantity of their meat.",
  },
];
export default Menu;
